import SingleModelInterface from '../../types/singleModelInterface'
import Option from './Option'
import getOptions from './getOptions'

export default function getCarEnginesOptions(
    models: SingleModelInterface[]
): Option {
    const fuels: string[] = []

    if (typeof models === 'undefined') {
        return {}
    }

    models.forEach((model) => {
        model.related_promotions.map((promo) => {
            fuels.push(...promo.fuels)
        })
    })

    return getOptions(fuels, true)
}
